import { Box, Container, Skeleton, Stack, useMediaQuery } from "@mui/material";
import { useLocation, useNavigation } from "react-router-dom";
import Loading from "./general/Loading";
import { useTheme } from "../context/ThemeContext";

/**
 * The skeleton of the page whose loader is running: the page a navigation
 * goes to, or on the first load, which is no navigation, the page opened.
 */
export const RouterSkeleton = () => {
  const { theme } = useTheme();
  const navigation = useNavigation();
  const location = useLocation();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  const targetPath = navigation.location?.pathname || location.pathname;

  if (targetPath === "/") {
    return (
      <Container maxWidth="md" sx={{ pt: theme.spacing(6) }}>
        <Skeleton variant="text" width={400} height={60} />
        <Skeleton
          variant="text"
          width={200}
          height={40}
          sx={{ mt: theme.spacing(1) }}
        />
        <Stack
          sx={{
            display: "flex",
            gap: theme.spacing(2),
            mt: theme.spacing(4),
            flexWrap: "wrap",
          }}
        >
          <Skeleton
            variant="rectangular"
            width={isSmall ? "100%" : 700}
            height={150}
          />
          <Skeleton
            variant="rectangular"
            width={isSmall ? "100%" : 700}
            height={150}
          />
        </Stack>
      </Container>
    );
  }

  if (targetPath === "/cases") {
    return (
      <Container maxWidth="md" sx={{ pt: theme.spacing(4) }}>
        <Skeleton variant="text" width={180} height={80} />
        <Skeleton
          variant="text"
          width={250}
          height={30}
          sx={{ mt: theme.spacing(1) }}
        />
        <Stack
          sx={{
            gap: theme.spacing(3),
            mt: theme.spacing(4),
          }}
        >
          {[...Array(6)].map((_, idx) => (
            <Skeleton
              key={idx}
              variant="rectangular"
              width="100%"
              height={180}
            />
          ))}
        </Stack>
      </Container>
    );
  }

  if (targetPath.startsWith("/portfolio")) {
    return (
      <Box
        sx={{
          display: "flex",
          height: "100vh",
          overflow: "hidden",
        }}
      >
        {/* the navigation, as wide as the one of the portfolio */}
        <Box
          sx={{
            width: { xs: 56, md: 232 },
            flexShrink: 0,
            bgcolor: "background.paper",
            borderRight: 1,
            borderColor: "divider",
          }}
        >
          <Skeleton variant="rectangular" width="100%" height="100%" />
        </Box>
        {/* the page: its title and what it is about, the filter bar, then
            the cards of its first section */}
        <Box sx={{ flexGrow: 1, minWidth: 0, px: 3.5, pt: 3.25 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2.25,
              maxWidth: 1080,
              mx: "auto",
            }}
          >
            <Box>
              <Skeleton variant="text" width={140} height={36} />
              <Skeleton variant="text" width="60%" />
            </Box>
            <Skeleton variant="rounded" height={50} width="100%" />
            <Skeleton variant="text" width={160} height={32} />
            <Skeleton variant="rounded" height={440} width="100%" />
            <Box sx={{ display: "flex", gap: 2.25 }}>
              <Skeleton variant="rounded" height={160} width="50%" />
              <Skeleton variant="rounded" height={160} width="50%" />
            </Box>
            <Skeleton variant="rounded" height={400} width="100%" />
          </Box>
        </Box>
      </Box>
    );
  }

  return <Loading />;
};
